import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { ApolloClient, InMemoryCache, ApolloProvider, } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'

import { StoreProvider } from './common/storeContext'

import App from './AppAff'
import MainPage from './pages/main'
import HelpPage from './pages/helpPage'
import ForgotPasswordPage from './pages/forgotpwdPage'
import ForgotUserPage from './pages/forgotUserPage'
import RegisterPage from './pages/registerPage'
import ContactusPage from './pages/contactUsPage'
import WalletPage from './pages/walletPage'
import MyProfilePage from './pages/profileMobile'
import LoginPage from './pages/loginPageMobile'

import OverviewPage from './pages/overviewPage'
import CommissionPlanPage from './pages/commissionPlanPage'



import Deposit from './sections/wallet/banking_info/deposit/default'
import Transfer from './sections/wallet/banking_info/transfer/default'
import Withdraw from './sections/wallet/banking_info/withdraw/default'
import Report from './sections/wallet/banking_info/report/default'
import UserInfo from './sections/wallet/my_account/user_info/default'
import ChangePassword from './sections/wallet/my_account/change_password/default'
import BankingDetails from './sections/wallet/my_account/banking_details/default'


// import i18n (needs to be bundled ;))
import './i18n';
import "bootstrap/dist/css/bootstrap.min.css";

const uploadLink = createUploadLink({
  uri: window.REACT_APP_API_URL,
  credentials: "include",
  headers: {
    'apollo-require-preflight': true,
  }
})

const client = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  link: uploadLink
});

const ErrorPage = () => {
  return (<div>Error</div>)
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <MainPage />
      },
      {
        path: "/login",
        element: <LoginPage />
      },
      {
        path: "/help",
        element: <HelpPage />
      },
      {
        path: "/contact-us",
        element: <ContactusPage />
      },
      {
        path: "/overview",
        element: <OverviewPage />
      },
      {
        path: "/commission-plan",
        element: <CommissionPlanPage />
      },
      {
        path: "/forgotpassword",
        element: <ForgotPasswordPage />
      },
      {
        path: "/forgotusername",
        element: <ForgotUserPage />
      },
      {
        path: "/register",
        element: <RegisterPage />
      },
      {
        path: "/wallet",
        element: <WalletPage />,
        children: [
          {
            index: true,
            element: <Deposit />,
          },
          {
            path: "deposit",
            element: <Deposit />,
          },
          {
            path: "transfer",
            element: <Transfer />,
          },
          {
            path: "withdraw",
            element: <Withdraw />,
          },
          {
            path: "report",
            element: <Report />,
          },
          {
            path: "user_info",
            element: <UserInfo />,
          },
          {
            path: "change_password",
            element: <ChangePassword />,
          },
          {
            path: "banking_details",
            element: <BankingDetails />,
          }
        ],
      },
      {
        path: "/my-profile",
        element: <MyProfilePage />
      }
    ]
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <StoreProvider>
        <RouterProvider router={router} />
      </StoreProvider>
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
